<template>
  <div class="confirm">
    <Flow v-bind:step="4"/>
    <Loading v-show="loading" />
    <ConfirmProductsList :edit="true" />

    <div class="confirm_credit bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">お支払い情報</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ detailData.paymentData.paymentMethodName }}</p>
          <p class="data_contents" v-if="detailData.paymentData.paymentMethod == 'CREDIT_CARD'">{{ detailData.creditData.cardNo }}</p>
        </div>
        <router-link v-if="detailData.creditData.deliveryTimeName != '全額ウォレット支払い'" class="edit btn_yellow btn_mini" :to="{ name: 'NSelectionSelectPaymentAndShipping' }">編集</router-link>
        <router-link v-else class="edit btn_yellow btn_mini" :to="{ name: 'NSelectionDiscount' }">編集</router-link>
      </div>
    </div>

    <div class="sum_total bg_white mt12 pt16 pb16">
      <h2 class="content_title sum">合計</h2>
      <AmountList />
      <a href="#" class="complete btn_blue" @click.stop.prevent="completeOrder()">確定</a>
      <router-link class="btn_delete back_btn" :to="{ name: 'NSelectionSelectPaymentAndShipping' }">戻る</router-link>
    </div>
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>
</template>

<script>
import Config from '@/config/config';
import { mapGetters } from 'vuex';
import scrollPosition from '@/model/scrollPosition';
import Loading from '@/components/common/Loading';
import ErrorModal from '@/components/common/ErrorModal';
import NSelection from '@/components/api/n-selection/n-selection';
import Flow from '@/components/n-selection/Flow';
import ConfirmProductsList from '@/components/n-selection/ConfirmProductsList';
import AmountList from '@/components/n-selection/AmountList';
import ProductFunction from '@/model/n-selection/selectProducts';
import ConfirmText from '@/components/common/ConfirmText';

export default {
  components: {
    Flow,
    Loading,
    ErrorModal,
    ConfirmProductsList,
    AmountList,
    ConfirmText
  },
  data() {
    return {
      isModalOpen: false,
      errorMessage: '注文に失敗しました。',
      loading: false,
    }
  },
  methods: {
    async completeOrder() {
      this.loading = true;
      // console.log('create order');
      console.log(ProductFunction.deleteOrderZeroItem(this.requestData));
      let requestData = ProductFunction.deleteOrderZeroItem(this.requestData);

      if(requestData) {
        await NSelection.createOrder(requestData).then((val) => {
          console.log('購入レスポンス');
          console.log(val);

          this.loading = false;
          let messages;
          let errorList = [];

          if(val.status && val.status != 200) {
            this.errorMessage = '予期せぬエラーが発生しました。<br>しばらくしてから再度お試しください。';
            if(val.message != null) {
              this.errorMessage += val.message;
            }
            this.modalOpen();
            return false;
          } else {
            if(val == 'error') {
              this.errorMessage = '受注作成でエラーが発生しました。';
              this.modalOpen();
              return false;
            }

            if(val.resultStatus == 'OK') {
              messages = '注文が完了しました。';
            }

            if(val.resultStatus == 'ALL_NG') {
              this.errorMessage = '受注作成でエラーが発生しました。';
              this.errorMessage += val.errorMessage != null ? val.errorMessage : '';
              if(val.productErrorList.length > 0) {
                for (var i = 0; i < val.productErrorList.length; i++) {
                  this.errorMessage += '<br>' + val.productErrorList[i].productName + ': ' + val.productErrorList[i].errorMessage;
                }
              }
              this.modalOpen();
              return false;
            }

            if(val.resultStatus == 'ALL_NG' && val.discountError) {
              this.errorMessage = '受注作成でエラーが発生しました。';
              this.errorMessage += val.errorMessage != null ? val.errorMessage : '';
              if(val.productErrorList.length > 0) {
                for (var i = 0; i < val.productErrorList.length; i++) {
                  this.errorMessage += '<br>' + val.productErrorList[i].productName + ': ' + val.productErrorList[i].errorMessage;
                }
              }

              this.modalOpen();
              return false;
            }

            if(val.resultStatus == 'SOME_NG') {
              messages = '受注作成でエラーが発生しました。<br>お手数ですが再度やり直してください。';
              errorList.push(...val.productErrorList);
            }

          }
          // 完了ページで戻るを押さずに閉じた時商品一覧でstoreをリセットする
          localStorage.setItem('nselectionOrderComplete', true);
          this.$router.push({ name: 'NSelectionComplete', params: {message: messages, errorList: errorList}});
        });

      }

    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    },
    async confirmOrder() {
      this.loading = true;
      console.log('confirmOrder リクエスト内容');
      console.log(ProductFunction.deleteOrderZeroItem(this.requestData));
      let requestData = ProductFunction.deleteOrderZeroItem(this.requestData);
      if(requestData) {
        await NSelection.confirmOrder(requestData).then((val) => {
          console.log('confirmOrder レスポンス');
          console.log(val);
          this.loading = false;
          if(val.status && val.status != 200) {
            this.errorMessage = '予期せぬエラーが発生しました。<br>しばらくしてから再度お試しください。';
            if(val.message != null) {
              this.errorMessage += val.message;
            }
            this.modalOpen();
            return;
          }
          this.$store.commit('nselection/setConfirmShipmentFee', val.shipmentFee);
        });
      }
    }
  },
  computed: mapGetters(
    'nselection', [
      'requestData',
      'detailData',
      'confirmShipmentFee'
    // 'purchaseCashOnDeliveryFee',
  ]),
  created () {
    this.confirmOrder();
  },
};
</script>

<style lang="css" scoped>
.content_title {
  width: 140px;
}
.content_title.sum {
  width: 120px;
}

.confirm_wrap {
  align-items: flex-end;
  /* border-bottom: 1px solid #C9C9C9; */
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 8px;
}
.edit {
  letter-spacing: 7.5px;
  margin: 0;
  text-indent: 7.5px;
}
.confirm_data {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1;
}
.data_wrap {
  margin-top: 14px;
}
.data_contents {
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}
.coupon_text {
  font-size: 12px;
  line-height: 1;
}
.count {
  font-size: 20px;
  margin-left: 25px;
}
.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}
.confirm_address .confirm_wrap {
  margin-top: 27px;
}
.confirm_credit .confirm_wrap {
  margin-top: 24px;
}
.confirm_coupon .confirm_wrap {
  margin-top: 30px;
}


.sum_total {
  padding-bottom: 48px;
}

.complete {
  margin-top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/views/n-selection/Confirm.vue